import client from './client';
import type {
  Deployment,
  DeploymentEnvironment,
  PaginatedResponse,
} from '@/types';

export interface DeploymentListParams {
  service_id?: string;
  environment_id?: string;
  status?: string;
  page?: number;
  page_size?: number;
}

export async function fetchDeployments(params?: DeploymentListParams) {
  const { data } = await client.get<PaginatedResponse<Deployment>>('/deployments', { params });
  return data;
}

export async function fetchDeployment(id: string) {
  const { data } = await client.get<Deployment>(`/deployments/${id}`);
  return data;
}

export async function fetchEnvironments() {
  const { data } = await client.get<DeploymentEnvironment[]>('/deployments/environments');
  return data;
}

export async function fetchLatestDeployments() {
  const { data } = await client.get<Deployment[]>('/deployments/latest');
  return data;
}
